import i18n from '../i18n';

export default class Utils {
    dataURLtoFile(dataurl, filename) {
        let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        
        while(n--)
            u8arr[n] = bstr.charCodeAt(n)

        return new File([u8arr], filename, {type:mime})
    }

    showScroll() {
        document.getElementsByTagName("body")[0].style.overflow = 'auto'
    }

    hideScroll() {
        document.getElementsByTagName("body")[0].style.overflow = 'hidden'
    }

    isObject(obj) {
        return obj && typeof obj === 'object'
    }
    isObjEmpty(obj) {
        Object.keys(obj).length === 0
    }

    goBack() {
        if (window.history.length === 0)
            this.goToLanding()
        else
            window.history.back()
    }
    goToLanding() {
        window.location.href = "/"
    }
    goToPage(url) {
        window.location.href = "/" + i18n.getCurrentLocale() + url
    }

    baseUrl() {
        return window.location.protocol + "//" + window.location.host
    }

    share(shareContent) { 
        navigator.clipboard.writeText(shareContent)
        alert.success("Copied!")
    }

    isEmail(email) {
        let re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return re.test(email)
    }

    scrollToTop() {
        window.scrollTo({top: 0, behavior: 'smooth'})
    }

    scrollTo(id) {
        document.getElementById(id).scrollIntoView({
            behavior: 'smooth'
        })
    }

    shuffle(array) {
        let currentIndex = array.length,  randomIndex;
      
        // While there remain elements to shuffle...
        while (currentIndex != 0) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;
      
            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
        }
      
        return array;
    }

    jsonToObject(mJson) {
        let mObj = null

        try {
            mObj = JSON.parse(mJson)   
        } catch (error) {
            return null
        }

        if (!this.isObject(mObj) || this.isObjEmpty(mObj))
            return null

        return mObj
    }

    jsonToArray(mJson) {
        let items = null

        try {
            items = JSON.parse(mJson)   
        } catch (error) {
            return []
        }

        return items
    }

    formLikedText(mObj, locale = 'en') {
        if (!mObj || !mObj.likes || mObj.likes.total === 0)
            return ''

        const translations = {
            en: {
                you_liked: 'You liked this',
                you_and_one: 'You and {name} liked this',
                you_and_others: 'You, {name} and {count} others liked this',
                you_and_two: 'You, {name} and 1 other liked this',
                one_liked: '{name} liked this',
                one_and_other: '{name} and 1 other liked this',
                one_and_others: '{name} and {count} others liked this'
            },
            ro: {
                you_liked: 'Ți-a plăcut asta',
                you_and_one: 'Ție și lui {name} v-a plăcut asta',
                you_and_others: 'Ție, lui {name} și altor {count} persoane le-a plăcut asta',
                you_and_two: 'Ție, lui {name} și încă unei persoane v-a plăcut asta',
                one_liked: 'Lui {name} i-a plăcut asta',
                one_and_other: 'Lui {name} și încă unei persoane le-a plăcut asta',
                one_and_others: 'Lui {name} și altor {count} persoane le-a plăcut asta'
            },
            fr: {
                you_liked: 'Vous avez aimé',
                you_and_one: 'Vous et {name} avez aimé',
                you_and_others: 'Vous, {name} et {count} autres personnes ont aimé',
                you_and_two: 'Vous, {name} et 1 autre personne ont aimé',
                one_liked: '{name} a aimé',
                one_and_other: '{name} et 1 autre personne ont aimé',
                one_and_others: '{name} et {count} autres personnes ont aimé'
            },
            it: {
                you_liked: 'Ti è piaciuto questo',
                you_and_one: 'A te e {name} è piaciuto questo',
                you_and_others: 'A te, {name} e altre {count} persone è piaciuto questo',
                you_and_two: 'A te, {name} e a un\'altra persona è piaciuto questo',
                one_liked: 'A {name} è piaciuto questo',
                one_and_other: 'A {name} e a un\'altra persona è piaciuto questo',
                one_and_others: 'A {name} e altre {count} persone è piaciuto questo'
            },
            pl: {
                you_liked: 'Polubiłeś to',
                you_and_one: 'Ty i {name} polubiliście to',
                you_and_others: 'Ty, {name} i {count} innych osób polubiło to',
                you_and_two: 'Ty, {name} i 1 inna osoba polubili to',
                one_liked: '{name} polubił(a) to',
                one_and_other: '{name} i 1 inna osoba polubili to',
                one_and_others: '{name} i {count} innych osób polubiło to'
            },
            ru: {
                you_liked: 'Вам это понравилось',
                you_and_one: 'Вам и {name} это понравилось',
                you_and_others: 'Вам, {name} и еще {count} людям это понравилось',
                you_and_two: 'Вам, {name} и еще одному человеку это понравилось',
                one_liked: '{name} это понравилось',
                one_and_other: '{name} и еще одному человеку это понравилось',
                one_and_others: '{name} и еще {count} людям это понравилось'
            },
            de: {
                you_liked: 'Dir gefällt das',
                you_and_one: 'Dir und {name} gefällt das',
                you_and_others: 'Dir, {name} und {count} anderen gefällt das',
                you_and_two: 'Dir, {name} und einer weiteren Person gefällt das',
                one_liked: '{name} gefällt das',
                one_and_other: '{name} und einer weiteren Person gefällt das',
                one_and_others: '{name} und {count} anderen gefällt das'
            },
            pt: {
                you_liked: 'Você gostou disto',
                you_and_one: 'Você e {name} gostaram disto',
                you_and_others: 'Você, {name} e mais {count} pessoas gostaram disto',
                you_and_two: 'Você, {name} e mais 1 pessoa gostaram disto',
                one_liked: '{name} gostou disto',
                one_and_other: '{name} e mais 1 pessoa gostaram disto',
                one_and_others: '{name} e mais {count} pessoas gostaram disto'
            },
            es: {
                you_liked: 'Te ha gustado esto',
                you_and_one: 'A ti y a {name} os ha gustado esto',
                you_and_others: 'A ti, a {name} y a {count} personas más les ha gustado esto',
                you_and_two: 'A ti, a {name} y a 1 persona más les ha gustado esto',
                one_liked: 'A {name} le ha gustado esto',
                one_and_other: 'A {name} y a 1 persona más les ha gustado esto',
                one_and_others: 'A {name} y a {count} personas más les ha gustado esto'
            },
            nl: {
                you_liked: 'Je vond dit leuk',
                you_and_one: 'Jij en {name} vonden dit leuk',
                you_and_others: 'Jij, {name} en {count} anderen vonden dit leuk',
                you_and_two: 'Jij, {name} en 1 ander vonden dit leuk',
                one_liked: '{name} vond dit leuk',
                one_and_other: '{name} en 1 ander vonden dit leuk',
                one_and_others: '{name} en {count} anderen vonden dit leuk'
            },
            el: {
                you_liked: 'Σας άρεσε αυτό',
                you_and_one: 'Σε εσάς και στον/στην {name} άρεσε αυτό',
                you_and_others: 'Σε εσάς, στον/στην {name} και σε {count} άλλους άρεσε αυτό',
                you_and_two: 'Σε εσάς, στον/στην {name} και σε έναν ακόμη άρεσε αυτό',
                one_liked: 'Στον/στην {name} άρεσε αυτό',
                one_and_other: 'Στον/στην {name} και σε έναν ακόμη άρεσε αυτό',
                one_and_others: 'Στον/στην {name} και σε {count} άλλους άρεσε αυτό'
            },
            uk: {
                you_liked: 'Вам це сподобалося',
                you_and_one: 'Вам і {name} сподобалося',
                you_and_others: 'Вам, {name} і ще {count} людям сподобалося',
                you_and_two: 'Вам, {name} і ще одному человіку сподобалося',
                one_liked: '{name} сподобалося',
                one_and_other: '{name} і ще одному человіку сподобалося',
                one_and_others: '{name} і ще {count} людям сподобалося'
            }
        }

        const t = translations[locale]

        if (mObj.liked) {
            if (mObj.likes.total > 3)
                return t.you_and_others.replace('{name}', mObj.likes.latest[0].user_name).replace('{count}', mObj.likes.total - 2)

            if (mObj.likes.total > 2)
                return t.you_and_two.replace('{name}', mObj.likes.latest[0].user_name)

            if (mObj.likes.total === 2)
                return t.you_and_one.replace('{name}', mObj.likes.latest[0].user_name)
            
            return t.you_liked
        }

        if (mObj.likes.total > 2)
            return t.one_and_others.replace('{name}', mObj.likes.latest[0].user_name).replace('{count}', mObj.likes.total - 1)

        if (mObj.likes.total > 1)
            return t.one_and_other.replace('{name}', mObj.likes.latest[0].user_name)

        return t.one_liked.replace('{name}', mObj.likes.latest[0].user_name)
    }

    formLikeCountText(count, locale = 'en') {        
        const translations = {
            en: {
                single: 'Like',
                multiple: 'Likes'
            },
            nl: {
                single: 'Vind-ik-leuk',
                multiple: 'Vind-ik-leuks'
            },
            fr: {
                single: 'J\'aime',
                multiple: "Mentions J'aime"
            },
            de: {
                single: 'Gefällt mir',
                multiple: 'Gefällt mir-Angaben'
            },
            el: {
                single: 'Αρέσει',
                multiple: 'Αρέσουν'
            },
            it: {
                single: 'Mi piace',
                multiple: 'Mi piacciono'
            },
            pl: {
                single: 'Polubienie',
                multiple: 'Polubienia'
            },
            pt: {
                single: 'Curtida',
                multiple: 'Curtidas'
            },
            ro: {
                single: 'Apreciez',
                multiple: 'Aprecieri'
            },
            es: {
                single: 'Me gusta',
                multiple: 'Me gusta'
            },
            uk: {
                single: 'Лайк',
                multiple: 'Лайки'
            }
        }

        if (!count || count === 0)
            return translations[locale].multiple;

        return count === 1 ? translations[locale].single : translations[locale].multiple;
    }

    likeText(locale = 'en') {
        const translations = {
            en: 'Like',
            nl: 'Vind-ik-leuk',
            fr: 'J\'aime',
            de: 'Gefällt mir',
            el: 'Μου αρέσει',
            it: 'Mi piace',
            pl: 'Lubię',
            pt: 'Gosto',
            ro: 'Apreciez',
            es: 'Me gusta',
            uk: 'Мені подобається'
        }

        return translations[locale]
    }
    
    getGenreLevelText(type, params, locale = 'en') {
        const genreLevelTranslations = {
            en: {
                movies_watched: '{genre} movies watched: {watched} of {total}',
                finish_watching: 'Finish watching <a href="/en/watch/{slug}" class="font-bold underline text-white mx-0.5">{title}</a> to activate <span class="text-white mx-0.5">{rank}</span> rank',
                watch_first: 'Watch your first {genre} movie to activate <span class="text-white mx-0.5">Casual {genre} Fan</span> rank'
            },
            ro: {
                movies_watched: 'Filme {genre} vizionate: {watched} din {total}',
                finish_watching: 'Termină de vizionat <a href="/ro/watch/{slug}" class="font-bold underline text-white mx-0.5">{title}</a> pentru a activa rangul <span class="text-white mx-0.5">{rank}</span>',
                watch_first: 'Vizionează primul tău film {genre} pentru a activa rangul <span class="text-white mx-0.5">Fan Casual {genre}</span>'
            },
            fr: {
                movies_watched: 'Films {genre} regardés: {watched} sur {total}',
                finish_watching: 'Finissez de regarder <a href="/fr/watch/{slug}" class="font-bold underline text-white mx-0.5">{title}</a> pour activer le rang <span class="text-white mx-0.5">{rank}</span>',
                watch_first: 'Regardez votre premier film {genre} pour activer le rang <span class="text-white mx-0.5">Fan Occasionnel {genre}</span>'
            },
            it: {
                movies_watched: 'Film {genre} guardati: {watched} su {total}',
                finish_watching: 'Finisci di guardare <a href="/it/watch/{slug}" class="font-bold underline text-white mx-0.5">{title}</a> per attivare il grado <span class="text-white mx-0.5">{rank}</span>',
                watch_first: 'Guarda il tuo primo film {genre} per attivare il grado <span class="text-white mx-0.5">Fan Occasionale {genre}</span>'
            },
            pl: {
                movies_watched: 'Obejrzane filmy {genre}: {watched} z {total}',
                finish_watching: 'Dokończ oglądanie <a href="/pl/watch/{slug}" class="font-bold underline text-white mx-0.5">{title}</a> aby aktywować rangę <span class="text-white mx-0.5">{rank}</span>',
                watch_first: 'Obejrzyj swój pierwszy film {genre}, aby aktywować rangę <span class="text-white mx-0.5">Okazjonalny Fan {genre}</span>'
            },
            ru: {
                movies_watched: 'Просмотрено фильмов {genre}: {watched} из {total}',
                finish_watching: 'Досмотрите <a href="/ru/watch/{slug}" class="font-bold underline text-white mx-0.5">{title}</a>, чтобы активировать ранг <span class="text-white mx-0.5">{rank}</span>',
                watch_first: 'Посмотрите свой первый фильм {genre}, чтобы активировать ранг <span class="text-white mx-0.5">Случайный фанат {genre}</span>'
            },
            de: {
                movies_watched: '{genre}-Filme gesehen: {watched} von {total}',
                finish_watching: 'Beende <a href="/de/watch/{slug}" class="font-bold underline text-white mx-0.5">{title}</a> um den Rang <span class="text-white mx-0.5">{rank}</span> zu aktivieren',
                watch_first: 'Schaue deinen ersten {genre}-Film um den Rang <span class="text-white mx-0.5">Gelegentlicher {genre}-Fan</span> zu aktivieren'
            },
            pt: {
                movies_watched: 'Filmes {genre} assistidos: {watched} de {total}',
                finish_watching: 'Termine de assistir <a href="/pt/watch/{slug}" class="font-bold underline text-white mx-0.5">{title}</a> para ativar o rank <span class="text-white mx-0.5">{rank}</span>',
                watch_first: 'Assista seu primeiro filme {genre} para ativar o rank <span class="text-white mx-0.5">Fã Casual de {genre}</span>'
            },
            es: {
                movies_watched: 'Películas {genre} vistas: {watched} de {total}',
                finish_watching: 'Termina de ver <a href="/es/watch/{slug}" class="font-bold underline text-white mx-0.5">{title}</a> para activar el rango <span class="text-white mx-0.5">{rank}</span>',
                watch_first: 'Mira tu primera película {genre} para activar el rango <span class="text-white mx-0.5">Fan Casual de {genre}</span>'
            },
            nl: {
                movies_watched: '{genre} films bekeken: {watched} van {total}',
                finish_watching: 'Maak het kijken van <a href="/nl/watch/{slug}" class="font-bold underline text-white mx-0.5">{title}</a> af om de rang <span class="text-white mx-0.5">{rank}</span> te activeren',
                watch_first: 'Bekijk je eerste {genre} film om de rang <span class="text-white mx-0.5">Casual {genre} Fan</span> te activeren'
            },
            el: {
                movies_watched: 'Ταινίες {genre} που έχετε δει: {watched} από {total}',
                finish_watching: 'Ολοκληρώστε την παρακολούθηση <a href="/el/watch/{slug}" class="font-bold underline text-white mx-0.5">{title}</a> για να ενεργοποιήσετε τον βαθμό <span class="text-white mx-0.5">{rank}</span>',
                watch_first: 'Δείτε την πρώτη σας ταινία {genre} για να ενεργοποιήσετε τον βαθμό <span class="text-white mx-0.5">Περιστασιακός Φαν {genre}</span>'
            },
            uk: {
                movies_watched: '{genre} фільми переглянуто: {watched} з {total}',
                finish_watching: 'Перегляньте <a href="/uk/watch/{slug}" class="font-bold underline text-white mx-0.5">{title}</a>, щоб активувати ранг <span class="text-white mx-0.5">{rank}</span>',
                watch_first: 'Перегляньте свій перший фільм {genre}, щоб активувати ранг <span class="text-white mx-0.5">Случайний фанат {genre}</span>'
            }
        };
        
        const translations = genreLevelTranslations[locale] || genreLevelTranslations['en'];
        let text = translations[type] || genreLevelTranslations['en'][type];

        // Replace all parameters in the text
        Object.keys(params).forEach(key => {
            text = text.replace(`{${key}}`, params[key]);
        });

        return text;
    } 
    
    getHighestTitle(user) {
        if (!user)
            return null
            
        let maxTitles = []

        if (user.influencer_titles.length > 0)
            maxTitles.push(user.influencer_titles.findMax('level'))

        if (user.movie_titles.length > 0)
            maxTitles.push(user.movie_titles.findMax('level'))

        return maxTitles.length > 0 ? maxTitles.findMax('level') : null
    }

    isElementInViewport(elId) {
        let el = document.getElementById(elId)
        let rect = el.getBoundingClientRect();
    
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    appendUrlQuery(query) {
        history.pushState('', 'WOCOO', window.location.protocol + '//' + window.location.host + window.location.pathname + query)
    }

    secsToTime(secs) {
        let tmp = secs

        const hours = String(Math.floor(tmp / 3600)).padStart(2, '0')
        tmp = tmp % 3600

        const minutes = String(Math.floor(tmp / 60)).padStart(2, '0')
        tmp = tmp % 60

        const seconds = String(Math.floor(tmp)).padStart(2, '0')

        return `${hours}:${minutes}:${seconds}`
    }

    getLevelProgressText(type, current, total, locale = 'en') {
        const progressTranslations = {
            en: {
                invites: 'Invites: {current} of {total}',
                followers: 'Followers: {current} of {total}',
                likes: 'Likes: {current} of {total}',
                comments: 'Comments: {current} of {total}',
                shares: 'Shares: {current} of {total}',
                reviews: 'Reviews: {current} of {total}',
                ratings: 'Ratings: {current} of {total}',
                watchlist: 'Watchlist: {current} of {total}'
            },
            ro: {
                invites: 'Invitații: {current} din {total}',
                followers: 'Urmăritori: {current} din {total}',
                likes: 'Aprecieri: {current} din {total}',
                comments: 'Comentarii: {current} din {total}',
                shares: 'Distribuiri: {current} din {total}',
                reviews: 'Recenzii: {current} din {total}',
                ratings: 'Evaluări: {current} din {total}',
                watchlist: 'Listă de vizionare: {current} din {total}'
            },
            fr: {
                invites: 'Invitations: {current} sur {total}',
                followers: 'Abonnés: {current} sur {total}',
                likes: 'J\'aime: {current} sur {total}',
                comments: 'Commentaires: {current} sur {total}',
                shares: 'Partages: {current} sur {total}',
                reviews: 'Critiques: {current} sur {total}',
                ratings: 'Évaluations: {current} sur {total}',
                watchlist: 'À voir: {current} sur {total}'
            },
            it: {
                invites: 'Inviti: {current} su {total}',
                followers: 'Follower: {current} su {total}',
                likes: 'Mi piace: {current} su {total}',
                comments: 'Commenti: {current} su {total}',
                shares: 'Condivisioni: {current} su {total}',
                reviews: 'Recensioni: {current} su {total}',
                ratings: 'Valutazioni: {current} su {total}',
                watchlist: 'Da vedere: {current} su {total}'
            },
            pl: {
                invites: 'Zaproszenia: {current} z {total}',
                followers: 'Obserwujący: {current} z {total}',
                likes: 'Polubienia: {current} z {total}',
                comments: 'Komentarze: {current} z {total}',
                shares: 'Udostępnienia: {current} z {total}',
                reviews: 'Recenzje: {current} z {total}',
                ratings: 'Oceny: {current} z {total}',
                watchlist: 'Do obejrzenia: {current} z {total}'
            },
            ru: {
                invites: 'Приглашения: {current} из {total}',
                followers: 'Подписчики: {current} из {total}',
                likes: 'Лайки: {current} из {total}',
                comments: 'Комментарии: {current} из {total}',
                shares: 'Поделились: {current} из {total}',
                reviews: 'Отзывы: {current} из {total}',
                ratings: 'Оценки: {current} из {total}',
                watchlist: 'Смотреть позже: {current} из {total}'
            },
            de: {
                invites: 'Einladungen: {current} von {total}',
                followers: 'Follower: {current} von {total}',
                likes: 'Likes: {current} von {total}',
                comments: 'Kommentare: {current} von {total}',
                shares: 'Geteilt: {current} von {total}',
                reviews: 'Bewertungen: {current} von {total}',
                ratings: 'Bewertungen: {current} von {total}',
                watchlist: 'Merkliste: {current} von {total}'
            },
            pt: {
                invites: 'Convites: {current} de {total}',
                followers: 'Seguidores: {current} de {total}',
                likes: 'Curtidas: {current} de {total}',
                comments: 'Comentários: {current} de {total}',
                shares: 'Compartilhamentos: {current} de {total}',
                reviews: 'Avaliações: {current} de {total}',
                ratings: 'Classificações: {current} de {total}',
                watchlist: 'Lista de espera: {current} de {total}'
            },
            es: {
                invites: 'Invitaciones: {current} de {total}',
                followers: 'Seguidores: {current} de {total}',
                likes: 'Me gusta: {current} de {total}',
                comments: 'Comentarios: {current} de {total}',
                shares: 'Compartidos: {current} de {total}',
                reviews: 'Reseñas: {current} de {total}',
                ratings: 'Calificaciones: {current} de {total}',
                watchlist: 'Por ver: {current} de {total}'
            },
            nl: {
                invites: 'Uitnodigingen: {current} van {total}',
                followers: 'Volgers: {current} van {total}',
                likes: 'Likes: {current} van {total}',
                comments: 'Reacties: {current} van {total}',
                shares: 'Gedeeld: {current} van {total}',
                reviews: 'Beoordelingen: {current} van {total}',
                ratings: 'Waarderingen: {current} van {total}',
                watchlist: 'Kijklijst: {current} van {total}'
            },
            el: {
                invites: 'Προσκλήσεις: {current} από {total}',
                followers: 'Ακόλουθοι: {current} από {total}',
                likes: 'Μου αρέσει: {current} από {total}',
                comments: 'Σχόλια: {current} από {total}',
                shares: 'Κοινοποιήσεις: {current} από {total}',
                reviews: 'Κριτικές: {current} από {total}',
                ratings: 'Βαθμολογίες: {current} από {total}',
                watchlist: 'Λίστα παρακολούθησης: {current} από {total}'
            },
            uk: {
                invites: 'Запрошення: {current} з {total}',
                followers: 'Підписники: {current} з {total}',
                likes: 'Лайки: {current} з {total}',
                comments: 'Коментарі: {current} з {total}',
                shares: 'Поширення: {current} з {total}',
                reviews: 'Відгуки: {current} з {total}',
                ratings: 'Оцінки: {current} з {total}',
                watchlist: 'Список перегляду: {current} з {total}'
            }
        };

        const translations = progressTranslations[locale] || progressTranslations['en'];
        let text = translations[type] || progressTranslations['en'][type];

        // Replace parameters in the text
        return text.replace('{current}', current).replace('{total}', total);
    }
}

export const getTranslationText = (type, targetLanguage, displayLanguage = null) => {
    if (!displayLanguage) {
        displayLanguage = targetLanguage;
    }

    const translations = {
        show_original: {
            en: 'Show original',
            nl: 'Toon origineel',
            fr: 'Afficher l\'original',
            de: 'Original anzeigen',
            el: 'Εμφάνιση πρωτότυπου',
            it: 'Mostra originale',
            pl: 'Pokaż oryginał',
            pt: 'Mostrar original',
            ro: 'Afișează originalul',
            es: 'Mostrar original',
            uk: 'Показати оригінал'
        },
        translate_to: {
            en: 'Translate to {language}',
            nl: 'Vertaal naar {language}',
            fr: 'Traduire en {language}',
            de: 'Übersetzen in {language}',
            el: 'Μετάφραση στα {language}',
            it: 'Traduci in {language}',
            pl: 'Przetłumacz na {language}',
            pt: 'Traduzir para {language}',
            ro: 'Tradu în {language}',
            es: 'Traducir a {language}',
            uk: 'Перекласти на {language}'
        },
        read_more: {
            en: 'Read more',
            nl: 'Meer lezen',
            fr: 'Lire la suite',
            de: 'Mehr lesen',
            el: 'Διαβάστε περισσότερα',
            it: 'Leggi di più',
            pl: 'Czytaj więcej',
            pt: 'Ler mais',
            ro: 'Citește mai mult',
            es: 'Leer más',
            uk: 'Читати більше'
        },
        show_less: {
            en: 'Show less',
            nl: 'Minder tonen',
            fr: 'Afficher moins',
            de: 'Weniger anzeigen',
            el: 'Εμφάνιση λιγότερων',
            it: 'Mostra meno',
            pl: 'Pokaż mniej',
            pt: 'Mostrar menos',
            ro: 'Afișează mai puțin',
            es: 'Mostrar menos',
            uk: 'Показати менше'
        }
    };

    const languageNames = {
        en: 'English',
        nl: 'Dutch',
        fr: 'French',
        de: 'German',
        el: 'Greek',
        it: 'Italian',
        pl: 'Polish',
        pt: 'Portuguese',
        ro: 'Romanian',
        es: 'Spanish',
        uk: 'Ukrainian'
    };

    const nativeLanguageNames = {
        en: 'English',
        nl: 'Nederlands',
        fr: 'Français',
        de: 'Deutsch',
        el: 'Ελληνικά',
        it: 'Italiano',
        pl: 'Polski',
        pt: 'Português',
        ro: 'Română',
        es: 'Español',
        uk: 'Українська'
    };

    let text = translations[type][displayLanguage] || translations[type]['en'];
    
    if (type === 'translate_to') {
        // Use native name for the target language
        const targetLanguageName = nativeLanguageNames[targetLanguage] || languageNames[targetLanguage] || targetLanguage;
        text = text.replace('{language}', targetLanguageName);
    }

    return text;
};

export function getTruncationText(type, targetLanguage) {
    const translations = {
        'Read more': {
            de: 'Mehr lesen',
            en: 'Read more',
            nl: 'Meer lezen',
            fr: 'Lire la suite',
            el: 'Διαβάστε περισσότερα',
            it: 'Leggi di più',
            pl: 'Czytaj więcej',
            pt: 'Ler mais',
            ro: 'Citește mai mult',
            es: 'Leer más',
            uk: 'Читати більше'
        },
        'Show less': {
            de: 'Weniger anzeigen',
            en: 'Show less',
            nl: 'Minder tonen',
            fr: 'Afficher moins',
            el: 'Εμφάνιση λιγότερων',
            it: 'Mostra meno',
            pl: 'Pokaż mniej',
            pt: 'Mostrar menos',
            ro: 'Afișează mai puțin',
            es: 'Mostrar menos',
            uk: 'Показати менше'
        }
    };

    const text = translations[type]?.[targetLanguage];
    return text || type;
}